import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductVersions from '../../ProductVersions/ProductVersions';
import { FormGroupProps } from './types';
import ReadOnlyField from '../../../common/ReadOnlyField/ReadOnlyField';

type Props = FormGroupProps & {
  handleVersion: (versions: string[]) => void;
  maxVersions?: number;
};

export default function ProductVersionsFormGroup({
  album,
  readonly,
  disabled,
  handleVersion,
  maxVersions,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      {!readonly ? (
        <div className="form-group">
          <label className="col-sm-3 form-label">
            {t('product.editProduct.version')}
          </label>
          <div className="col-sm-8 product-artist">
            <ProductVersions
              versions={album.albumMetaData?.versions ?? []}
              handleVersion={handleVersion}
              disabled={disabled}
              maxVersions={maxVersions}
            />
          </div>
        </div>
      ) : (
        <ReadOnlyField
          id={'productVersions'}
          labelTitle={t('product.editProduct.versions')}
          value={album.albumMetaData?.versions}
          mode={'list'}
        ></ReadOnlyField>
      )}
    </>
  );
}
